<template>
  <span class="ds-toggle" :class="{ 'ds-toggle--on': on }" aria-hidden="true">
    <span class="ds-toggle__knob"></span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// The switch drawn in detail-sheet rows. Visual only: the button around it
// carries the click and, where it is the row's own control, role="switch".
export default defineComponent({
  name: 'DetailSheetToggle',
  props: {
    on: { type: Boolean, default: false },
  },
});
</script>

<style scoped>
.ds-toggle {
  position: relative;
  display: block;
  width: 42px;
  height: 21px;
  border-radius: 10.5px;
  background: #363636;
  transition: background-color 0.15s ease;
}

.ds-toggle--on {
  background: var(--green);
}

.ds-toggle__knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}

.ds-toggle--on .ds-toggle__knob {
  transform: translateX(21px);
}
</style>
